import { genericPage, getServerSidePropsHelper } from 'components/corporatiu/Page';
import { useRouter } from 'next/router';

const path = ['web', process.env.FOLDER_LAYOUTS_CORPORATIU, 'atencio', 'sx3'];

const Pagina = (props) => {
    const router = useRouter();
    return genericPage(props, router, path);
};

export async function getServerSideProps(context) {
    return getServerSidePropsHelper(context, { slugs: path });
}

export default Pagina;
